import { render } from "./PatientNurse.vue?vue&type=template&id=2c070144&scoped=true"
import script from "./PatientNurse.vue?vue&type=script&lang=js"
export * from "./PatientNurse.vue?vue&type=script&lang=js"

import "./PatientNurse.vue?vue&type=style&index=0&id=2c070144&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c070144"]])

export default __exports__